/**
 * Copyright (c) 2018 Mathis Zeiher
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */

/* globals Map Symbol */
import { CustomElement } from './customelement.js';
const interceptorMapSymbol = Symbol('property_symbol');
/**
 * PropertyInterceptor Type
 */

/**
 * get all interceprors for a property of a class
 *
 * @param target - Class to get interceptors from
 * @param property - property which will be intercepted
 */
export function getClassPropertyInterceptor(target, property) {
  // for ES5 compatibility since static properties are not inherited we must manually traverse the protoype chain (for es6 everything works fine)
  let interceptorDescriptor = Object.getOwnPropertyDescriptor(target, interceptorMapSymbol);

  if (!interceptorDescriptor) {
    // no interceptor descriptor for class properties
    const interceptorMap = new Map();
    Object.defineProperty(target, interceptorMapSymbol, interceptorDescriptor = {
      enumerable: false,
      configurable: true,
      get: function () {
        return interceptorMap;
      }
    });
  }

  let interceptorArray = interceptorDescriptor.get().get(property);

  if (!interceptorArray) {
    const prototype = Object.getPrototypeOf(target); // get protoype to copy interceptors

    if (prototype !== CustomElement) {
      // as long as protoype is not CustomElement copy from base class
      const superInterceptors = getClassPropertyInterceptor(prototype, property);
      interceptorArray = [...superInterceptors];
      interceptorDescriptor.get().set(property, interceptorArray);
    } else {
      interceptorArray = [];
      interceptorDescriptor.get().set(property, interceptorArray);
    }
  }

  return interceptorArray;
}
